var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 9.75A.75.75 0 0 1 7.25 9V6.5a.75.75 0 0 1 1.5 0V9a.75.75 0 0 1-.75.75zM7 11.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.49 1.99a1.75 1.75 0 0 0-2.98 0L.298 12.084c-.718 1.166.121 2.667 1.49 2.667H14.21c1.37 0 2.208-1.501 1.49-2.667L9.49 1.99zm-1.703.787a.25.25 0 0 1 .426 0l6.21 10.092a.25.25 0 0 1-.213.381H1.79a.25.25 0 0 1-.214-.381l6.21-10.092z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export default ForwardRef;